import React from 'react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import _ from 'lodash';
import { Box, Checkbox, HStack, Input, Tooltip, Text, useDisclosure } from '@chakra-ui/react';
import SortableTable from 'components/Segments/SortableTable';
import useSearchResults, { ResultLink } from 'hooks/useSearchResults';
import useDecisions from 'hooks/useDecisions';
import useNoo from 'hooks/useNoo';
import { AddOption } from 'components/Decisions/OptionsList';
import { VoteTotalBox } from './Styled';
import { DetailsDrawer } from '../Decisions/OptionDetails';
import SimpleCloud from '../Segments/SimpleCloud';

import { objectSort, multiSort, truncate_precision, median } from 'utils';
import {
  getOptionTitle,
  // getOptionTallyType,
  getOptionTotalCharLength,
  addTalliesToOptions
} from 'utils/decisions';

const PollTable = props => {
  const kind = 'options';
  const { data, topic } = props;
  const { nooUser } = useNoo('PollTable');
  const [mockOptions, setMockOptions] = useState([
    { title: 'option1', description: 'this is', voters: [] },
    { title: 'option2', description: 'this is too ', voters: [] }
  ]);
  const [newOptionData, setNewOptionData] = useState({});
  const [maxAnswer, setMaxAnswer] = useState(1);
  const [avgAnswer, setAvgAnswer] = useState(1);
  const [sortString, setSortString] = useState('');
  const [cloud, setCloud] = useState([]);
  const me = 'foo';
  const my_groups = useMemo(() => {
    return nooUser ? _.union(nooUser?.member, nooUser?.owner) : [];
  }, [nooUser]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const useDrawer = true;

  const {
    currentDecision,
    currentOptionId,
    isActive,
    decisions,
    currentOption,
    addOptionError,
    getOptionById,
    getOptionVote,
    addAnswerToCurrentDecision,
    addOptionToCurrentDecision
  } = useDecisions();

  const {
    defaultColumnProperties,
    map_column_title,
    map_column_sx,
    get_columns
  } = useSearchResults(kind);

  const filter = e => {
    const str = e.target.value;
    setSortString(e.target.value);
  };
  useEffect(() => {
    let new_cloud = [];
    const options = currentDecision?.options || [];
    if (options) {
      const tallies = _.filter(options, opt => {
        return opt.total ? true : false;
      });
      if (tallies.length > 0) {
        _.forEach(options, function (option) {
          let word = {
            value: option.data.label,
            count: option.total || 0,
            _id: option._id
          };
          new_cloud.push(word);
        });
      }
    }
    setCloud(new_cloud);
  }, [currentDecision?.options]);

  const doCheckOption = useCallback(
    (index, is_checked) => {
      let now = new Date();
      const current = [...mockOptions];
      let which = current[index] || {};
      const voters = new Set(which.voters);
      if (is_checked) {
        voters.add(me);
      } else {
        voters.delete(me);
      }
      which.voters = voters;
      current[index] = which;
      setMockOptions(current);

      // onChecked(pid, is_checked, myChecked.length);
    },
    [mockOptions]
  );

  const loadOptionData = useCallback(
    optionId => {
      if (useDrawer) onOpen();
      if (optionId) {
        getOptionById(optionId);
      }
    },
    [getOptionById, onOpen, useDrawer] // , onOpen, useDrawer]
  );

  const clickRow = useCallback(
    e => {
      let dataset = e.target.dataset;
      if (!dataset.option) {
        const parent = e.target.parentElement;
        dataset = parent.dataset;
      }
      if (dataset.option) {
        const option = JSON.parse(dataset.option);
        const _id = option?._id;
        loadOptionData(_id);
      }
    },
    [loadOptionData]
  );

  const optionRows = useMemo(() => {
    const onCheckOption = e => {
      const index = e.target.value;
      const is_checked = e.target.checked;
      doCheckOption(index, is_checked);
    };
    const handleCheckboxVote = (event, option) => {
      const vote = event.target.value > 0 ? 0 : avgAnswer; // binary on or off for checkbox click
      // console.log('check', vote, event.target.value, maxAnswer, avgAnswer);
      addAnswerToCurrentDecision({ optionId: option._id, vote });
    };
    let them = currentDecision?.options; // mockOptions
    if (them?.length > 0) {
      const rows = addTalliesToOptions(currentDecision, them);
      return rows
        .map((option, index) => {
          if (option) {
            const data = option.data; // option
            const title = data.title || data.label || data.prompt;
            const match =
              sortString.length > 0 ? title.toLowerCase().indexOf(sortString) > -1 : true;

            const optionVote = getOptionVote({ decision: currentDecision, option }) / maxAnswer;
            const hasPositiveVote = optionVote > 0;
            const voters = Object.values(option.votes).filter(val => val > 0).length;
            return {
              visible: match,
              titleSorter: title,
              title: <Tooltip label={data.description}>{title}</Tooltip>,
              description: data.description,
              score: (
                <VoteTotalBox maxChars={3} isHighlighted={hasPositiveVote}>
                  {truncate_precision(option.total)}
                </VoteTotalBox>
              ), //maxCharsInOptionTotals
              scoreSorter: option.total,
              people: <Text>{voters}</Text>,
              peopleSorter: voters,
              checkbox: (
                <Checkbox
                  // onChange={onCheckOption}
                  onChange={event => handleCheckboxVote(event, option)}
                  isChecked={hasPositiveVote}
                  isDisabled={!nooUser}
                  value={hasPositiveVote ? 1 : 0}
                  sx={{ backgroundColor: 'white', borderColor: '#999' }}
                  colorScheme='green'
                  variant='solid'
                  size='md'
                  name={'options'}
                  // defaultChecked={myChecked.includes(pid)}
                  key={index}
                ></Checkbox>
              ),
              onClick: clickRow,
              option: option
              // checkboxSorter = !option.is_checked;
            };
          }
        })
        .filter(it => it.visible);
    } else {
      return [];
    }
  }, [
    addAnswerToCurrentDecision,
    avgAnswer,
    clickRow,
    currentDecision,
    doCheckOption,
    getOptionVote,
    maxAnswer,
    nooUser,
    sortString
  ]);

  const maxCharsInOptionTotals = useMemo(() => {
    if (optionRows?.length) {
      return getOptionTotalCharLength(optionRows.map(option => truncate_precision(option.total)));
    }
    return 1;
  }, [optionRows]);

  const cols = useMemo(() => {
    if (optionRows?.length) {
      return get_columns(optionRows[0]).map(key => {
        return {
          ...defaultColumnProperties,
          key: key,
          name: map_column_title(_.capitalize(key), kind),
          sx: map_column_sx(key, kind)
        };
      });
    }
    return [];
  }, [defaultColumnProperties, get_columns, optionRows, map_column_sx, map_column_title]);

  const addMockOptionToCurrentDecision = ({ label, description }) => {
    const current = [...mockOptions];
    const newOption = { title: label, description, created: new Date().toISOString(), voters: [] };
    current.push(newOption);
    setMockOptions(current);
  };
  const updateNewOptionData = e => {
    // console.log('updatenewoption', e.target.name, e.target.value, newOptionData);
    const myOptionData = { ...newOptionData };
    myOptionData[e.target.name] = e.target.value;
    setNewOptionData(myOptionData);
  };

  const handleAddOption = () => {
    let { label, description } = newOptionData;
    label = label ? label.trim() : '';
    description = description || null; // allow one space for no description? description.trim() : '';
    // description is not required
    if (label) {
      description = description || (confirm('Submit without a description?') ? '' : null);
      if (description != null) {
        addOptionToCurrentDecision({ label, description });
        // addMockOptionToCurrentDecision({ label, description });
        setNewOptionData({});
      }
    }
  };

  // !newOptionData.label ||
  const loggedIn = nooUser ?? false;
  return (
    <Box mt='20px'>
      {/* {cloud.length > 0 && <SimpleCloud data={cloud} />} */}
      <HStack>
        <Text>Before suggesting, try keywords for existing matches:</Text>
        <Input sx={{ width: '200px', backgroundColor: 'white' }} onChange={filter} />
      </HStack>

      <AddOption
        disabled={!loggedIn}
        type={'option'}
        onChange={updateNewOptionData}
        onSubmit={handleAddOption}
        prompt={'Suggest something new'} /* data?.prompt || */
        label={newOptionData?.label}
        description={newOptionData?.description}
      />

      {optionRows?.length > 0 && (
        <SortableTable
          disabled={!loggedIn}
          columns={cols}
          rows={optionRows}
          sortCol={0}
          sortDir={'desc'}
        />
      )}
      {loggedIn && <DetailsDrawer isOpen={isOpen} onOpen={onOpen} onClose={onClose} />}
    </Box>
  );
};

export default PollTable;
